import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'code',
            headerName: getLocalizedString("code"),
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'name',
            headerName: getLocalizedString("nameAndSurname"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'targetType',
            headerName: getLocalizedString("objectiveType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'statusName',
            headerName: getLocalizedString("objectiveStatus"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'assignerName',
            headerName: getLocalizedString("objectiveAssigner"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'targetName',
            headerName: getLocalizedString("objective"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'targetWeighting',
            headerName: getLocalizedString("objectiveWeight"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'targetDescription',
            headerName: getLocalizedString("objectiveDescription"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["goalsAndObjectivesAllPeriods"],
        config: {
            field: 'periodString',
            headerName: getLocalizedString("period"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'startDate',
            headerName: getLocalizedString("assignationDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'endDate',
            headerName: getLocalizedString("endDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'progressStatus',
            headerName: getLocalizedString("progressStatus"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'progress',
            headerName: getLocalizedString("tasks"),
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'progressDate',
            headerName: getLocalizedString("progressDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'feedbacksQuantity',
            headerName: getLocalizedString("feedbacks"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'relatedTask',
            headerName: getLocalizedString("relatedTask"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.goalsAndObjectives, "goalsAndObjectivesAllPeriods"],
        config: {
            field: 'revisionDate',
            headerName: getLocalizedString("revisionDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
]